import { useRef } from "react";
import { motion } from "framer-motion";
import { TESTIMONIALS } from "../data";
import { Star, BadgeCheck, ChevronLeft, ChevronRight } from "lucide-react";
import { WhatsAppButton } from "./WhatsAppButton";

export const Testimonials = () => {
  const scroller = useRef(null);

  const scrollBy = (dir) => {
    const el = scroller.current;
    if (!el) return;
    const amount = el.clientWidth * 0.8;
    el.scrollBy({ left: dir * amount, behavior: "smooth" });
  };

  return (
    <section id="referenzen" className="relative scroll-mt-24 overflow-hidden py-24 md:py-32">
      <div className="aurora right-[8%] top-[14%] h-72 w-72 bg-[#3B82F6] opacity-20" />

      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative mb-10 text-center md:mb-14"
        >
          <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#60A5FA] sm:text-sm">Echte WhatsApp-Nachrichten</span>
          <h2 className="mt-3 font-heading text-[1.7rem] font-extrabold tracking-tight text-white sm:text-4xl md:text-5xl">
            Das schreiben unsere <span className="gradient-text">Fahrer</span>
          </h2>
          <div className="mt-4 flex items-center justify-center gap-2">
            <span className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-4 w-4 fill-[#60A5FA] text-[#60A5FA] sm:h-5 sm:w-5" />
              ))}
            </span>
            <span className="text-xs font-semibold text-gray-300 sm:text-sm">Unzählige zufriedene Überführungen</span>
          </div>
        </motion.div>
      </div>

      {/* Swipe-Karussell */}
      <div className="relative">
        {/* Desktop Pfeile */}
        <button
          onClick={() => scrollBy(-1)}
          data-testid="ref-prev"
          aria-label="Zurück"
          className="absolute left-3 top-1/2 z-20 hidden h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full border border-white/15 bg-black/60 text-white backdrop-blur-md transition-all hover:scale-110 hover:bg-black/80 md:flex"
        >
          <ChevronLeft className="h-5 w-5" />
        </button>
        <button
          onClick={() => scrollBy(1)}
          data-testid="ref-next"
          aria-label="Weiter"
          className="absolute right-3 top-1/2 z-20 hidden h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full border border-white/15 bg-black/60 text-white backdrop-blur-md transition-all hover:scale-110 hover:bg-black/80 md:flex"
        >
          <ChevronRight className="h-5 w-5" />
        </button>

        <div
          ref={scroller}
          data-testid="ref-scroller"
          className="flex snap-x snap-mandatory gap-4 overflow-x-auto scroll-smooth px-5 pb-4 md:px-16 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
        >
          {TESTIMONIALS.map((t, i) => (
            <div
              key={i}
              data-testid={`testimonial-${i}`}
              className="group w-[78vw] max-w-[300px] shrink-0 snap-center overflow-hidden rounded-2xl border border-white/10 bg-[#0B111E] transition-all duration-300 hover:border-[#60A5FA]/40 sm:w-[300px]"
            >
              <div className="relative bg-black">
                <img
                  src={t.image}
                  alt={`Überführung ${t.vehicle}`}
                  loading="lazy"
                  draggable="false"
                  className="block h-auto w-full object-contain"
                />
                <div className="absolute left-2.5 top-2.5 inline-flex items-center gap-1.5 rounded-full bg-black/65 px-2.5 py-1 text-[11px] font-bold text-[#60A5FA] backdrop-blur-md">
                  <BadgeCheck className="h-3.5 w-3.5" /> Verifiziert
                </div>
              </div>

              <div className="border-t border-white/5 p-4">
                <p className="text-sm leading-relaxed text-gray-200">"{t.text}"</p>
                <div className="mt-3 flex items-center justify-between">
                  <div>
                    <div className="text-sm font-bold text-white">{t.name}</div>
                    <div className="text-xs text-gray-400">{t.vehicle}</div>
                  </div>
                  <div className="flex">
                    {[...Array(5)].map((_, j) => (
                      <Star key={j} className="h-3.5 w-3.5 fill-[#60A5FA] text-[#60A5FA]" />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Swipe-Hinweis Mobile */}
        <p className="mt-2 text-center text-[11px] text-gray-500 md:hidden">← nach links / rechts wischen →</p>
      </div>

      <div className="mt-10 flex justify-center px-5">
        <WhatsAppButton size="lg" testid="referenzen-whatsapp" label="Werde der Nächste – jetzt starten" />
      </div>
    </section>
  );
};
